






















































import { defineComponent, getCurrentInstance, ComponentInternalInstance, computed } from '@vue/composition-api';
import headbar from '@/renderer/views/desktop/headbar/index.vue';
import UserLogo from '@/renderer/components/user/components/UserLogo.vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import PasswordForm from '@/renderer/components/user/components/passwordForm.vue';
import successIcon from '@/renderer/assets/images/Icon/svg/successPay.svg';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import resetHandler from './compositions/resetHandler';
export default defineComponent({
  components: {
    headbar,
    UserLogo,
    BaseIcon,
    PasswordForm,
  },
  provide: {
    hideLoginEntry: true,
  },
  setup() {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const mobileStyle = computed(() => store.getters.isMobile || store.getters.isMobileStyle);
    const { resetToken, loading, isExpired, resetDetail, resetDone, methods: resetMethods } = resetHandler();
    const userBaseInfo = computed(() => {
      return {
        nickName: resetDetail.nickname,
        avatar: resetDetail.avatar,
      };
    });
    const methods = {
      // 进入网盘
      enterCofile() {
        dispatchRouter(
          {
            name: 'login',
          },
          'replace',
        );
      },
      async init() {
        resetMethods.getDetail();
      },
      async onReset(params: CoFile.EditUserPassword) {
        const success = await resetMethods.reset({
          accountName: params.accountName as string,
          accountPassword: params.newPassword,
          resetToken,
        });
        resetDone.value = success;
      },
    };
    methods.init();
    return {
      successIcon,
      mobileStyle,
      loading,
      resetDetail,
      isExpired,
      userBaseInfo,
      resetDone,
      ...methods,
    };
  },
});
